import React from "react";
import { SimpleShowLayout, TextField, NumberInput } from "react-admin";

const FormTab = (props) => {
  function s(p) {
    return props.side + "." + p;
  }
  return (
    <SimpleShowLayout {...props}>
      <TextField source={s("season.team.name")} />
      <TextField source={s("id")} />
      <TextField source={s("basketball.id")} />
      <NumberInput source={s("basketball.totalPoints")} />
      <NumberInput source={s("basketball.firstQuarterPoints")} />
      <NumberInput source={s("basketball.secondQuarterPoints")} />
      <NumberInput source={s("basketball.thirdQuarterPoints")} />
      <NumberInput source={s("basketball.fourthQuarterPoints")} />
      <NumberInput source={s("basketball.overtimePoints")} />
      <NumberInput source={s("basketball.overtime2Points")} />
      <NumberInput source={s("basketball.overtime3Points")} />
    </SimpleShowLayout>
  );
};

export default FormTab;
